<a [routerLink]="['/']">
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 74.2 14.5"
    xml:space="preserve">
    <g>
      <g class="svg-brand-group">
        <polygon
          style="fill:#FFFFFF;"
          points="11.7,5.9 15.8,0 10.6,0 9,2.2"></polygon>
        <polygon
          style="fill:#FFFFFF;"
          points="4.5,8.4 0,14.5 5.6,14.5 7.2,12.2"></polygon>
        <polygon
          style="fill:#FFFFFF;"
          points="0.2,0 5.7,0 16.1,14.5 10.5,14.5"></polygon>
        <polygon
          style="fill:#FFFFFF;"
          points="30.5,0 26.5,0 21.9,7.7 17.3,0.3 13.1,6.2 13.1,8 17.6,14.2 17.6,8.1 20.7,13.2 22.9,13.2 26,7.9
    26.1,14.5 30.5,14.5"></polygon>
      </g>
      <g class="svg-product-name-group">
        <path
          style="fill:#FFFFFF;"
          d="M68.2,5.4h-1.1v2.1h1.1c0.8,0,1.3-0.4,1.3-1C69.5,5.8,69.1,5.4,68.2,5.4z"></path>
        <path
          style="fill:#FFFFFF;"
          d="M72.2,0.5L38,0.6c-1.1,0-2,0.9-2,2V12c0,1.1,0.9,2,2,2l34.2-0.1c1.1,0,2-0.9,2-2V2.5
          C74.2,1.4,73.3,0.5,72.2,0.5z M44.7,10.2l0-3.5l-1.7,2.9h-0.6l-1.7-2.8v3.5h-1.3V4.3h1.1L42.7,8l2.2-3.7h1.1l0,5.9H44.7z
          M52.1,10.2h-4.6V4.3H52v1.1h-3.1v1.3h2.7v1.1h-2.7v1.4h3.2V10.2z M58.4,5.4h-1.9v4.8h-1.4V5.4h-1.9V4.3h5.1V5.4z M64.3,10.2h-4.6
          V4.3h4.4v1.1h-3.1v1.3h2.7v1.1h-2.7v1.4h3.2V10.2z M69.5,10.2l-1.1-1.6h-0.1h-1.2v1.6h-1.4V4.3h2.5c1.6,0,2.6,0.8,2.6,2.1
          c0,0.9-0.4,1.5-1.2,1.9l1.3,1.9H69.5z"></path>
      </g>
    </g>
  </svg>
</a>
